import React from "react"
import {Typography} from "@mui/material";
import {metaDataProperty} from "../preview/previewMetaData";
import {usePreviewContext} from "../../context/PreviewContext";

interface Props {
    title?: string | null,
    propertyName?: string,
    isH1Activated?: boolean
    metadataId?: string
}

function CCOH1(props: Props) {
    const isPreview = usePreviewContext().isPreview;
    return props.isH1Activated && props.title && props.title.length > 0 ?
        <Typography variant={'h1'} textAlign={'center'} marginTop={2} marginBottom={8} {...metaDataProperty(isPreview, props.propertyName, props.metadataId)}>
            {props.title}
        </Typography>
        : <React.Fragment/>

}

export default CCOH1